import React, { useState, useEffect, useMemo } from 'react';
import { useCart } from '../../hooks/useCart';
import { useToast } from '../../context/ToastContext';
import SubNavbar from '../../components/layout/SubNavbar';
import HeroSlider from '../../components/store/HeroSlider';
import QuickViewModal from '../../components/store/QuickViewModal';
import CartDrawer from '../../components/store/CartDrawer';
import CheckoutModal from '../../components/store/CheckoutModal';
import ServiceFeatures from '../../components/store/ServiceFeatures';
import FlashSale from '../../components/store/FlashSale';
import ProductSection from '../../components/ProductSection';
import ActionButtons from '../../components/common/ActionButtons';
import { getAllProducts, findAllCategory } from '../../api/productApi/ProductApi';

// Import thêm ô cửa sổ Yêu thích mới tạo vào đây
import WishlistDrawer from '../../components/store/WishlistDrawer';

export default function Home({ products: initialProducts = [], categories: initialCategories = [] }) {
    const { addToCart } = useCart();
    const { showToast } = useToast();

    const [productList, setProductList] = useState(initialProducts);
    const [categoriesList, setCategoriesList] = useState(initialCategories);

    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedCategoryLabel, setSelectedCategoryLabel] = useState('Tất Cả Sản Phẩm');
    const [searchQuery, setSearchQuery] = useState('');
    const [priceRange, setPriceRange] = useState(10000000);
    const [quickViewProduct, setQuickViewProduct] = useState(null);
    const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState('');


// Hàm nhận giá trị khi người dùng click chọn danh mục trên Navbar
const handleSelectCategoryFromNavbar = (catKey, catName) => {
  setSelectedCategory(catKey);
  setSelectedCategoryLabel(catName);
};
    // 1. Tự động fetch sản phẩm & danh mục động từ Backend khi tải trang Home
    useEffect(() => {
        const fetchHomeData = async () => {
            try {
                const resProducts = await getAllProducts(0, 50);
                const list = resProducts?.data?.data || resProducts?.data || [];
                if (Array.isArray(list) && list.length > 0) {
                    setProductList(list);
                }

                const resCategories = await findAllCategory();
                const rawCatList = resCategories?.data || resCategories || [];

               const allOption = { id: 'all', name: 'Tất Cả Sản Phẩm', subCategories: [] };

                if (Array.isArray(rawCatList)) {
                    // Lọc lấy các danh mục gốc (không có parent hoặc parentId bằng null)
                    const rootCategories = rawCatList.filter(cat => !cat.parentId && (!cat.parent || !cat.parent.id));
                    
                    setCategoriesList([allOption, ...rawCatList]);
                } else {
                    setCategoriesList([allOption]);
                }
               
            } catch (error) {
                console.error("Lỗi lấy dữ liệu trang Home:", error);
            }
        };

        fetchHomeData();
    }, []);
    useEffect(() => {
        const handleTriggerQuickView = () => {
            const savedProduct = localStorage.getItem('quickViewTarget');
            if (savedProduct) {
                setQuickViewProduct(JSON.parse(savedProduct)); // Gán sản phẩm vào state mở modal
                localStorage.removeItem('quickViewTarget'); // Xóa bộ nhớ tạm sau khi dùng xong
            }
        };

        window.addEventListener('triggerQuickViewFromSearch', handleTriggerQuickView);
        return () => window.removeEventListener('triggerQuickViewFromSearch', handleTriggerQuickView);
    }, []);


    const handleAddToCart = (product, qty, color, size) => {
        addToCart(product, qty, color, size);
    };

    const filteredProducts = useMemo(() => {
        if (!Array.isArray(productList)) return [];

       return productList.filter((p) => {
            const matchSearch = searchQuery
                ? p.name?.toLowerCase().includes(searchQuery.toLowerCase())
                : true;

            const productPrice = Number(p.price) || 0;
            const matchPrice = productPrice <= priceRange;

            return matchSearch && matchPrice;
        });
    }, [productList, selectedCategory, searchQuery, priceRange]);

    return (
        <div className="bg-white">
            <SubNavbar
                categories={categoriesList}
                onSelectCategory={handleSelectCategoryFromNavbar}
            />

            <HeroSlider />

            {toastMessage && (
                <div className="fixed bottom-6 right-6 z-50 bg-slate-900 text-white px-5 py-3 rounded-2xl shadow-2xl text-xs font-bold border border-slate-800">
                    {toastMessage}
                </div>
            )}

            <QuickViewModal
                product={quickViewProduct}
                onClose={() => setQuickViewProduct(null)}
                addToCart={handleAddToCart}
            />

            <CartDrawer onOpenCheckout={() => setIsCheckoutOpen(true)} />

            {/* Gọi Cửa sổ Yêu thích hiển thị tại đây giống CartDrawer */}
            <WishlistDrawer allProducts={productList} />

            <CheckoutModal
                isOpen={isCheckoutOpen}
                onClose={() => setIsCheckoutOpen(false)}
                onSuccess={showToast}
            />

            {/* 3. Truyền mảng sản phẩm đã được lọc (filteredProducts) */}
            <ProductSection
                products={filteredProducts}
                addToCart={handleAddToCart}
                onQuickView={setQuickViewProduct} // <-- THÊM CHÍNH XÁC DÒNG NÀY ĐỂ MỞ MODAL
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectedCategoryLabel={selectedCategoryLabel}
                setSelectedCategoryLabel={setSelectedCategoryLabel}
            />

            <FlashSale addToCart={handleAddToCart} />
            <ServiceFeatures />
            <ActionButtons />
        </div>
    );
}